import { KUDOS_SUPPORT_EMAIL } from '@globals/constants/supportEmail.const'
import { colors } from '@globals/themes/defaultTheme'
import { tabletQuery } from '@globals/themes/themeConstants'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { T } from '@transifex/react'
import { useState } from 'react'

const ContactToUpgradeButton: React.FC = () => {
  const isTablet = useMediaQuery(tabletQuery)
  const [showCopiedMsg, setShowCopiedMsg] = useState(false)

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(KUDOS_SUPPORT_EMAIL).then(() => {
        setShowCopiedMsg(true)
        window.setTimeout(() => setShowCopiedMsg(false), 5000)
      })
    }
  }

  const handleClick = (): void => {
    copyToClipboard()
    window.location.assign(`mailto:${KUDOS_SUPPORT_EMAIL}`)
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button
        id="btnContactUsToUpgrade"
        variant="contained"
        onClick={handleClick}
        sx={{ mt: { xs: 0, sm: 0 } }}
        fullWidth={isTablet ? true : undefined}>
        <T _str="Email us to upgrade" />
      </Button>
      {showCopiedMsg && (
        <Typography variant="caption" display="flex" alignItems="center" gap={0.5}>
          <ContentCopyOutlinedIcon
            fontSize="small"
            sx={{ color: `${colors.grayMedium} !important` }}
          />
          <T _str="Email copied to clipboard!" />
        </Typography>
      )}
    </Stack>
  )
}

export default ContactToUpgradeButton
